import __pages_import_0__ from "/src/pages/index.vue";
const __pages_import_1__ = () => import("/src/pages/room/[...name]/highlight.vue");
const __pages_import_2__ = () => import("/src/pages/room/[...name]/index.vue");
const __pages_import_3__ = () => import("/src/pages/room/[...name]/obs.vue");

const routes = [{"name":"index","path":"/","component":__pages_import_0__,"props":true},{"name":"room-name-highlight","path":"/room/:name(.*)/highlight","component":__pages_import_1__,"props":true},{"name":"room-name","path":"/room/:name(.*)","component":__pages_import_2__,"props":true},{"name":"room-name-obs","path":"/room/:name(.*)/obs","component":__pages_import_3__,"props":true}];

export default routes;